<template>
  <v-dialog
    v-model="shown"
    persistent
    scrollable
    max-width="500px"
  >
    <v-card>
      <v-card-title>{{ title }}</v-card-title>
      <v-divider></v-divider>
      <v-card-text>
        <template>
          <v-treeview
            v-if="multiple"
            v-model="select"
            :items="selectedTreeData"
            selection-type="leaf"
            selectable
            return-object
            open-all
          ></v-treeview>
          <v-treeview
            v-else
            return-object
            activatable
            shaped

            :active.sync="select"
            open-all
            :items="selectedTreeData"
          ></v-treeview>
        </template>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>

        <v-btn
          text
          color="secondary"
          @click="closeDialog"
        >
          关闭
        </v-btn>
        <v-btn
          v-if="multiple"
          text
          color="error"
          @click="resetNode()"
        >
          清空
        </v-btn>
        <v-btn
          text
          color="primary"
          @click="choiseNode()"
        >
          保存
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'TreeSelect',
  model: {
    prop: 'shown',
    event: 'update:tree-select-dialog',
  },
  props: {
    title: {
      type: String,
      default: '树状选择器',
    },
    selectedTreeData: {
      type: Array,
      require: true,
    },
    shown: {
      required: true,
      type: Boolean,
      default: false,
    },
    multiple: {
      type: Boolean,
      default: false,
    },
    active: {
      type: Array,
    },
  },
  data() {
    return {
      select: this.active,
    }
  },
  watch: {
    active(newVal, oldVal) {
      this.select = newVal
    },
  },
  methods: {
    choiseNode() {
      this.$emit('update:tree-select-dialog', false)
      this.$emit('getActive', this.select)
    },
    closeDialog() {
      this.$emit('update:tree-select-dialog', false)
    },
    resetNode() {
      this.select = []
    },
  },
}
</script>
